import React from 'react'
import { PaginaType } from 'utils/types'
import useTrans from '@hooks/useTrans'
import { ChevronLeft } from '@components/atoms/Icons'
import { Button, WContainer } from '@components/atoms'
import {
  FormRecuperaPassword,
  FormResetPassword,
  FormResendActivation,
  Page,
} from '@components/organisms'
import styles from './RecuperaPasswordTemplate.module.sass'

interface Props {
  pagina: PaginaType
  token?: string
  type: 'recupera' | 'reset'
}

const RecuperaPasswordTemplate = (props: Props) => {
  const { pagina, token = '', type } = props

  const t = useTrans()

  return (
    <Page
      pagina={pagina}
      item={{}}
      contentClassName={styles.recuperaPasswordTemplate}
    >
      <WContainer variant="xs">
        <div className={styles.container}>
          {(!!pagina.titolo || !!pagina.descrizione) && (
            <div className={styles.head}>
              {!!pagina.titolo && <h1 className={styles.title}>{pagina.titolo}</h1>}
              {!!pagina.descrizione && (
                <div
                  className={styles.description}
                  dangerouslySetInnerHTML={{ __html: pagina.descrizione }}
                />
              )}
            </div>
          )}
          {token && type === 'reset' ? (
            <FormResetPassword token={token} />
          ) : type === 'recupera' ? (
            <FormRecuperaPassword />
          ) : null}
        </div>
      </WContainer>
    </Page>
  )
}

export default RecuperaPasswordTemplate
